import * as css from 'css/exports.module.scss';
import { InitiativeStatus } from '@sonar-software/sonar-core';
import { Space } from 'antd';
import { ANTD_INITIATIVES_STATUS_COLORS, INITIATIVES_STATUS } from '@sonar-software/sonar-ts-constants';
import { CheckCircleTwoTone, ClockCircleTwoTone, PlayCircleTwoTone, PlusCircleTwoTone, QuestionCircleTwoTone } from '@ant-design/icons';
import React, { memo } from 'react';
function getInitiativeStatus(statusId) {
    switch (statusId) {
        case InitiativeStatus.New:
            return INITIATIVES_STATUS.NEW;
        case InitiativeStatus.Ready:
            return INITIATIVES_STATUS.READY;
        case InitiativeStatus.InProgress:
            return INITIATIVES_STATUS.IN_PROGRESS;
        case InitiativeStatus.Finished:
            return INITIATIVES_STATUS.FINISHED;
        case InitiativeStatus.Testing:
            return INITIATIVES_STATUS.TESTING;
        default:
            return undefined;
    }
}
function getInitiativeStatusColor(statusId) {
    switch (statusId) {
        case InitiativeStatus.New:
        case InitiativeStatus.Ready:
            return ANTD_INITIATIVES_STATUS_COLORS.BLUE;
        case InitiativeStatus.InProgress:
        case InitiativeStatus.Testing:
            return ANTD_INITIATIVES_STATUS_COLORS.ORANGE;
        case InitiativeStatus.Finished:
            return ANTD_INITIATIVES_STATUS_COLORS.GREEN;
        default:
            return undefined;
    }
}
function getIcon(initiativeStatusId) {
    var _a;
    const color = (_a = getInitiativeStatusColor(initiativeStatusId)) !== null && _a !== void 0 ? _a : '';
    switch (initiativeStatusId) {
        case InitiativeStatus.New:
            return React.createElement(PlusCircleTwoTone, { twoToneColor: color });
        case InitiativeStatus.Ready:
            return React.createElement(PlayCircleTwoTone, { twoToneColor: color });
        case InitiativeStatus.InProgress:
            return React.createElement(ClockCircleTwoTone, { twoToneColor: color });
        case InitiativeStatus.Testing:
            return React.createElement(QuestionCircleTwoTone, { twoToneColor: color });
        case InitiativeStatus.Finished:
            return React.createElement(CheckCircleTwoTone, { twoToneColor: color });
        default:
            return null;
    }
}
export const InitiativeStatusDisplay = memo(({ statusId }) => React.createElement(Space, { size: Number(css.size4) },
    getIcon(statusId),
    getInitiativeStatus(statusId)));
